import React, { useState, useEffect } from 'react';
import { Text, Button, HStack, Box, IconButton, VStack } from '@chakra-ui/react';
import { AiOutlineClose } from 'react-icons/all';
import { useCallback } from 'react';

interface ModalProps {
  children: React.ReactNode;
  numberOfBookings: number;
}

export const ModalView = (props: ModalProps): JSX.Element => {
  const { children, numberOfBookings } = props;
  const [isOpen, setIsOpen] = useState<Boolean>(false);
  const [windowOffset, setWindowOffset] = useState<number>(0);

  const openModal = useCallback(() => {
    setIsOpen(true);
    setWindowOffset(window.scrollY);
    document.body.setAttribute(
      'style',
      `position: fixed; top: -${window.scrollY}px; left:0; right:0;`,
    );
  }, [isOpen]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    document.body.setAttribute('style', '');
    window.scrollTo(0, windowOffset);
  }, [setIsOpen, windowOffset]);

  useEffect(() => {
    return () => {
      !openModal && closeModal();
    };
  }, []);

  return (
    <Box>
      <VStack bg={'white'} p={0} alignItems={'flex-end'}>
        <Button
          fontSize={'15px'}
          align="center"
          colorScheme={'blue'}
          onClick={openModal}
          cursor={'pointer'}>
          Filter + Verfügbarkeit
        </Button>
      </VStack>
      <Box
        pb={16}
        bgColor={'white'}
        position={'fixed'}
        top={0}
        left={0}
        right={0}
        bottom={0}
        overflowY={'auto'}
        overflowX={'hidden'}
        maxWidth="100vw"
        zIndex="100000"
        className={isOpen ? 'open' : ''}
        css={{
          '&': {
            opacity: 0,
            height: 0,
          },
          '&.open': {
            display: 'block',
            opacity: 1,
            transition: 'opacity 0.5s ease 0s',
            height: 'auto',
          },
        }}>
        <HStack
          display={isOpen ? 'flex' : 'none'}
          position={'fixed'}
          w={'100%'}
          justify={'space-between'}
          pl={2}
          bgColor={'white'}
          zIndex={2}
          shadow={'lg'}
          h={'50px'}>
          <Text textStyle={'category.primary'} fontSize={'20px'}>
            Filter
          </Text>
          <IconButton
            fontSize={'20px'}
            onClick={closeModal}
            borderRadius={'none'}
            colorScheme={'blue'}
            icon={<AiOutlineClose />}
            aria-label={'close filter'}
            variant="ghost"
            h={'100%'}
          />
        </HStack>

        {children}

        <HStack
          width={'100%'}
          justifyContent={'flex-end'}
          display={isOpen ? 'flex' : 'none'}
          position={'fixed'}
          bottom={0}
          zIndex={2}
          backgroundColor={'var(--chakra-colors-white)'}
          boxShadow={'0 -12px 10px -3px rgba(0, 0, 0, 0.1), 0 0 4px -2px rgba(0, 0, 0, 0.5)'}
          padding={'10px 0'}
          paddingRight={'var(--chakra-space-4)'}
          right={0}
          left={0}>
          <Button
            variant={'primary'}
            onClick={closeModal}
            colorScheme={'blue'}
            alignSelf={'flex-end'}>
            Zu den Ergebnissen ({numberOfBookings})
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};
